import BreakerSection from './components/BreakerSection';
import ElecDetailTable from './components/ElecDetailTable';
import ElecOpinionPanel from './components/ElecOpinionPanel';
import ElecSummaryCards from './components/ElecSummaryCards';
import UtMatrixElecSelector from './components/UtMatrixElecSelector';
import VoltGroupPanel from './components/VoltGroupPanel';
import { UtComparisonElecRoot } from './styles';

/**
 * UT Matrix 전기사양 비교 분석 (설비사양 > UT Matrix)
 * 현업 HTML 툴(UT_Matrix_비교분석_Rev15.html)의 전/후 UT Matrix 비교 로직을 ELM DB 데이터
 * 기준으로 전환한 화면. 전기 관련 칼럼만 비교하며(CDA 이하 기계 계열 UT는 제외), 코드(표준설비ID)
 * +Line+전압유형 키로 전/후 행을 매핑해 일치/변경/추가/삭제를 판정한다.
 */
const UtComparisonElecPage = () => {
  return (
    <UtComparisonElecRoot>
      <UtMatrixElecSelector />

      <ElecSummaryCards />
      <VoltGroupPanel />
      <ElecDetailTable />
      <BreakerSection />
      <ElecOpinionPanel />
    </UtComparisonElecRoot>
  );
};

export default UtComparisonElecPage;
